/* eslint-disable @typescript-eslint/no-explicit-any */
// TODO: This file was automatically migrated to TypeScript by `dev typescript migrate`.
//  The eslint disable comment above should be removed and the resulting errors fixed.
import React from 'react';

import * as OnboardingActions from 'actions/OnboardingActions';
import notifications from 'notifications';
import PublicReferralLink from 'start/PublicReferralLink';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';

import EmailInvite from './EmailInvite';

interface Props {
  email?: string;
  name?: string;
}

type State = any;

class ExternalInvitePage extends React.Component<Props, State> {
  state: State = {
    inviterEmail: this.props.email || '',
  };

  inviteMembers = (emails: any, recaptcha: any): void => {
    const {inviterEmail} = this.state;
    if (emails.length === 0) {
      notifications.error('Please specify an email address to invite.');
      return;
    }

    if (!inviterEmail) {
      notifications.error('Please enter your email.');
      return;
    }

    OnboardingActions.externalInviteUsers({
      emails,
      inviter: {
        email: this.state.inviterEmail,
        name: this.props.name ? this.props.name : '',
      },
      recaptcha,
    });
  };

  _showInviterEmailInput = (): boolean => !this.props.email;

  _renderInviterEmailInput = (): JSX.Element | null => {
    if (!this._showInviterEmailInput()) {
      return null;
    }
    return (
      <div className="invitePage-inviterEmail">
        <FormGroup>
          <TextField
            isRequired={true}
            label="Enter your email to receive credit for your referrals"
            value={this.state.inviterEmail}
            placeholder="Enter your email"
            onChange={(e) => {
              this.setState({inviterEmail: e.target.value});
            }}
          />
        </FormGroup>
      </div>
    );
  };

  render(): JSX.Element {
    return (
      <div className="invitePage">
        <Row>
          <Col md={12} className="u-spacing-bottom">
            <div className="col-centered">
              <div className="u-xlarge-text">Love Benchling? Invite other scientists and receive $100!</div>
              <div className="u-spacing-top invitePage-description">
                <p>
                  <strong>$100 Amazon.com Gift Card*</strong>
                  {' for every industry referral (scientist or IT) that results in a qualified demo. '}
                  <span className="legacy-font-proxima-12">
                    (*Restrictions apply, see{' '}
                    <a href="https://amazon.com/gc-legal" target="_blank" rel="noopener noreferrer">
                      amazon.com/gc-legal
                    </a>
                    .)
                  </span>
                </p>
              </div>
              {this._renderInviterEmailInput()}
              {this._showInviterEmailInput() && <FieldLabel label="Invitations" isRequired={true} />}
              <EmailInvite onInvite={this.inviteMembers} />
              {this.props.email && (
                <div className="u-flex-display u-spacing-top">
                  <PublicReferralLink email={this.props.email} />
                </div>
              )}
              <div className="u-spacing-top">
                <p>
                  (Scientists you invite will join Benchling's main deployment and not your company's
                  deployment.)
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default ExternalInvitePage;
